import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Swords, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Countdown from "@/components/Countdown";

export default function LiveNowStrip() {
  const { data: battles = [] } = useQuery({
    queryKey: ["battles"], queryFn: async () => (await api.get("/battles")).data,
    staleTime: 30_000,
  });
  const live = battles.find((b) => b.status === "active") || battles.find((b) => b.status === "voting");
  if (!live) return null;
  const voting = live.status === "voting";

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8">
      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="comic-card p-4 sm:p-5 flex flex-col sm:flex-row items-center gap-4 !bg-ink"
        data-testid="live-now-strip"
      >
        <span className="flex items-center gap-2 shrink-0">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
          </span>
          <span className="font-display font-900 text-neon uppercase text-sm tracking-wide">
            {voting ? "Voting Live" : "Battle Live"}
          </span>
        </span>

        <div className="flex items-center gap-3 flex-1 min-w-0 text-center sm:text-left">
          <Swords className="w-5 h-5 text-neon shrink-0 hidden sm:block" />
          <div className="min-w-0">
            <p className="font-display font-900 text-cream text-base sm:text-lg uppercase truncate">
              #{String(live.number || 1).padStart(3, "0")} · {live.title}
            </p>
            {live.endsAt
              ? <Countdown endsAt={live.endsAt} />
              : <span className="font-mono text-xs text-dim">{voting ? "Cast your vote now" : "Drop your meme now"}</span>}
          </div>
        </div>

        <Link
          to={`/battles/${live.id}`}
          className="btn-neon !py-2 !px-4 !text-xs shrink-0"
          data-testid="live-now-join-btn"
        >
          {voting ? "Vote Now" : "Join The Battle"} <ArrowRight className="w-4 h-4" />
        </Link>
      </motion.div>
    </section>
  );
}
